import { Col, Row } from 'antd'
import React from 'react'
import ByMuvuImage from '../images/ByMuvu.svg';

const ByMuvu = () => {
  return (
    <Row justify='center'>
      <Col span={24}>
        <p className="text-center text-orange mb-0">
          Plataforma desarrollada
        </p>
      </Col>
      <Col span={24} className='text-center'>
        <img alt='check' src={ByMuvuImage} width={70} />
      </Col>
    </Row>
  )
}

export default ByMuvu;
